import React, { useEffect, useState, useMemo } from 'react';
import {
    Button,
    Dialog, DialogActions, DialogContent, DialogTitle,
    Typography, makeStyles, OutlinedInput, InputAdornment
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SearchIcon from '@material-ui/icons/Search';
import Avatar from '@material-ui/core/Avatar';



const useStyles = makeStyles((theme) => ({
    customDialogPaper: (props) => ({
        width: props.dialogWidth || 428,
        border: '1px solid rgba(224, 224, 224, 1)',
        borderRadius: '8px',
        maxWidth: 'none',
    }),

    dialogContentRoot: {
        '&.MuiDialogContent-root': {
            padding: '0 !important',
        },
        '&.MuiDialogContent-dividers': {
            padding: '0 !important',
        },
    },


    infoText: {
        fontWeight: 400,
        fontSize: 14,
        color: 'rgba(33, 33, 33, 1)',
        [theme.breakpoints.down('xs')]: { fontSize: 13 },
    },

    // searchInputRoot: {
    //     // borderRadius: '8px',
    //     backgroundColor: '#f8f9fa',
    //     // border: '1px solid #dee2e6',
    //     '&:hover': {
    //         backgroundColor: '#e9ecef',
    //         border: '1px solid #adb5bd',
    //     },
    //     '&.Mui-focused': {
    //         backgroundColor: '#ffffff',
    //         border: '2px solid #007bff',
    //         boxShadow: '0 0 0 0.2rem rgba(0, 123, 255, 0.25)',
    //     },
    // },
    // searchInputInput: {
    //     height: '32px',
    //     padding: '12px 14px',
    //     fontSize: '14px',
    //     color: '#495057',
    // },

    // inputField: { width: '100%', height: 35, paddingLeft: 5 },
    // smallOutlinedInput: {
    //     fontSize: 12,
    //     height: '32px',
    //     padding: '5px 8px 6px 8px',
    //     '& input': { padding: '5px 4px 6px 4px', fontSize: 12 },
    // },
    // searchInput: {
    //     width: '100%',
    //     height: 40,
    //     fontSize: 14,
    //     '& .MuiOutlinedInput-root': {
    //         borderRadius: '6px',
    //         backgroundColor: '#f5f5f5',
    //         '&:hover': {
    //             backgroundColor: '#eeeeee',
    //         },
    //         '&.Mui-focused': {
    //             backgroundColor: '#ffffff',
    //             boxShadow: '0 0 0 2px rgba(63, 81, 181, 0.2)',
    //         },
    //     },
    //     '& .MuiOutlinedInput-input': {
    //         padding: '10px 12px',
    //         fontSize: 14,
    //     },
    // },

    inputRoot: {
        height: '32px',
        padding: '5px 8px 6px 8px',
        borderRadius: '4px',
        backgroundColor: '#fff',
        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid rgba(213, 214, 221, 1)',
        },
    },
    inputRoot1: {
        height: '32px',
        width: '100%',
        padding: '5px 8px 6px 8px',
        borderRadius: '4px',
        backgroundColor: '#fff',
        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid rgba(213, 214, 221, 1)',
        },
    },
    inputText: {
        fontSize: '12px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '17px',
    },
    purple: {
        backgroundColor: '#5398E6',
        color: 'rgba(255, 255, 255, 1)',
    },
    rowStartCenter: { display: 'flex', justifyContent: 'start', alignItems: 'center' }
}));


const WorkFlowModelViewer = (props) => {
    const {
        appId, formData, modalInfo, onCloseModel, onNoLater, onJustSaveClick, defaultOptionsDropdown, onAssignToFirstStepMembers, onSaveMembersToFirstStep, onAssignToParent, onAssignTo, onSucessClick, onRejectedModel, onSucessNextRespondentClick, onRejectedNextRespondentClick
    } = props;
    const { document } = formData;
    const { chartUniqueId, chartData } = props.data

    const [searchTerm, setSearchTerm] = useState('');

    const [selectedAssigneeId, setSelectedAssigneeId] = useState({});


    const classes = useStyles({ dialogWidth: ((modalInfo.type === 'delete' || modalInfo.type === 'save' || modalInfo.type === 'JustSave') ? 405 : ((modalInfo.type === 'success' || modalInfo.type === 'rejected') ? 330 : 428)) });

    useEffect(() => {
        if (modalInfo.enable) {
            if (modalInfo.type === 'delete') {

            }
        }
    }, [modalInfo]);

    const getInitials = (name) => {
        if (!name) return '?';
        return name
            .split(' ')
            .map(word => word.charAt(0))
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredUsers = useMemo(() => {
        if (!defaultOptionsDropdown) return [];

        if (!searchTerm.trim()) {
            return defaultOptionsDropdown;
        }

        return defaultOptionsDropdown.filter(user =>
            user.label?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.email?.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [defaultOptionsDropdown, searchTerm]);

    return (
        <Dialog
            open={modalInfo.enable}
            fullWidth={true}
            classes={{ paper: classes.customDialogPaper }}
            maxWidth={'md'}
            aria-labelledby='comparision-dialog-title'
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
        >

            {
                modalInfo.type === 'success' && (
                    <div>
                        <DialogContent>
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '24px', gap: '16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img
                                        src={'/media/svg/moveNext.svg'}
                                        alt="Move Next"
                                        width="48px"
                                        height="48px"
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Typography
                                            component='span'
                                            style={{ fontWeight: '400', fontSize: '14px', color: 'rgba(33, 33, 33, 1)', fontStyle: 'medium' }}
                                        >
                                            Successfully Moved
                                        </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Typography
                                            component='span'
                                            style={{ fontWeight: '400', fontSize: '12px', color: 'rgba(97, 97, 97, 1)', fontStyle: 'medium', textAlign: 'center' }}
                                        >
                                            {modalInfo.message}
                                        </Typography>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Button
                                        style={{ backgroundColor: 'rgba(46, 125, 50, 1)', color: 'rgba(255, 255, 255, 1)' }}
                                        size='small'
                                        onClick={() => {
                                            if (modalInfo.nextRespondent) {
                                                onSucessNextRespondentClick()
                                            } else {
                                                onSucessClick()
                                            }
                                        }}

                                    >
                                        OKAY
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </div>
                )
            }
            {
                modalInfo.type === 'rejected' && (
                    <div>
                        <DialogContent>
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '24px', gap: '16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img
                                        src={'/media/svg/movePrevious.svg'}
                                        alt="Move Previous"
                                        width="48px"
                                        height="48px"
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Typography
                                            component='span'
                                            style={{ fontWeight: '400', fontSize: '14px', color: 'rgba(33, 33, 33, 1)', fontStyle: 'medium' }}
                                        >
                                            Rejected
                                        </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Typography
                                            component='span'
                                            style={{ fontWeight: '400', fontSize: '12px', color: 'rgba(97, 97, 97, 1)', fontStyle: 'medium', textAlign: 'center' }}
                                        >
                                            {modalInfo.message}
                                        </Typography>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Button
                                        style={{ backgroundColor: 'rgba(46, 125, 50, 1)', color: 'rgba(255, 255, 255, 1)' }}
                                        size='small'
                                        onClick={() => {
                                            if (modalInfo.nextRespondent) {
                                                onRejectedNextRespondentClick()
                                            } else {
                                                onRejectedModel()
                                            }
                                        }}

                                    >
                                        OKAY
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </div>
                )
            }

            {
                modalInfo.type === 'delete' && (
                    <div>
                        <DialogContent>
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '24px', gap: '16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '48px' }}>
                                    <img
                                        src={'/media/svg/deleteTaskConfimation.svg'}
                                        alt="Delete"
                                        width="48px"
                                        height="48px"
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography style={{ fontSize: 14, fontWeight: 400, color: 'rgba(33, 33, 33, 1)', fontStyle: 'normal', lineHeight: '27px', textAlign: 'center' }}>
                                        Delete Confirmation
                                    </Typography>
                                    <Typography style={{ fontSize: 14, fontWeight: 400, color: 'rgba(97, 97, 97, 1)', fontStyle: 'normal', lineHeight: '24px', textAlign: 'center' }}>
                                        Are you sure you want to delete this document?
                                    </Typography>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px', height: '38px', boxSizing: 'border-box' }}>
                                    <Button variant="outlined" size="small" style={{ width: '170px', height: '100%', boxSizing: 'border-box', padding: '12px', border: '1px solid #212121', borderRadius: '4px', color: 'rgba(33, 33, 33, 1)', fontSize: 14, fontWeight: 400, fontStyle: 'normal', lineHeight: '21px' }}>
                                        CANCEL
                                    </Button>
                                    <Button variant="contained" size='small' style={{ width: '170px', height: '100%', boxSizing: 'border-box', padding: '12px', backgroundColor: 'rgba(255, 71, 71, 1)', borderRadius: '4px', color: 'rgba(255, 255, 255, 1)', fontSize: 14, fontWeight: 400, fontStyle: 'normal', lineHeight: '21px' }}>
                                        YES DELETE
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </div>
                )
            }

            {
                modalInfo.type === 'save' && (
                    <div>
                        <DialogContent>
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '24px', gap: '16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '48px' }}>
                                    <img
                                        src={'/media/svg/moveNext.svg'}
                                        alt="Delete"
                                        width="48px"
                                        height="48px"
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography style={{ fontSize: 14, fontWeight: 400, color: 'rgba(33, 33, 33, 1)', fontStyle: 'normal', lineHeight: '27px', textAlign: 'center' }}>
                                        Success! Opportunity Created
                                    </Typography>
                                    <Typography style={{ fontSize: 14, fontWeight: 400, color: 'rgba(97, 97, 97, 1)', fontStyle: 'normal', lineHeight: '24px', textAlign: 'center' }}>
                                        Do you want to assign this opportunity to someone?
                                    </Typography>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px', height: '38px', boxSizing: 'border-box' }}>
                                    <Button variant="outlined" size="small" style={{ width: '170px', height: '100%', boxSizing: 'border-box', padding: '12px', border: '1px solid rgba(63, 81, 181, 1)', borderRadius: '4px', color: 'rgba(63, 81, 181, 1)', fontSize: 14, fontWeight: 400, fontStyle: 'normal', lineHeight: '21px' }} onClick={() => onNoLater()}>
                                        No, Later
                                    </Button>
                                    <Button variant="contained" size='small' style={{ width: '170px', height: '100%', boxSizing: 'border-box', padding: '12px', backgroundColor: 'rgba(63, 81, 181, 1)', borderRadius: '4px', color: 'rgba(255, 255, 255, 1)', fontSize: 14, fontWeight: 400, fontStyle: 'normal', lineHeight: '21px' }} onClick={() => onAssignToFirstStepMembers()}>
                                        Yes, Assign
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </div>
                )
            }

            {
                modalInfo.type === 'JustSave' && (
                    <div>
                        <DialogContent>
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '24px', gap: '16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '48px' }}>
                                    <img
                                        src={'/media/svg/moveNext.svg'}
                                        alt="Delete"
                                        width="48px"
                                        height="48px"
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography style={{ fontSize: 14, fontWeight: 400, color: 'rgba(33, 33, 33, 1)', fontStyle: 'normal', lineHeight: '27px', textAlign: 'center' }}>
                                        Success! Opportunity Created
                                    </Typography>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px', height: '38px', boxSizing: 'border-box' }}>
                                    <Button variant="contained" size='small' style={{ width: '170px', height: '100%', boxSizing: 'border-box', padding: '12px', backgroundColor: 'rgba(63, 81, 181, 1)', borderRadius: '4px', color: 'rgba(255, 255, 255, 1)', fontSize: 14, fontWeight: 400, fontStyle: 'normal', lineHeight: '21px' }} onClick={() => onJustSaveClick()}>
                                        Ok
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </div>
                )
            }

            {
                modalInfo.type === 'assignTo' && (
                    <div>
                        {
                            props.formData?.[chartUniqueId + '_Current_Step_Assigning_Upated_loading'] || props.formData?.[chartUniqueId + '_execute_create_Workflow_loading'] || props.formData?.[chartUniqueId + '_Create_Task_ID_loading'] || props.formData?.[chartUniqueId + '_Create_Task_loading'] || props.formData?.[chartUniqueId + '_First_Step_Members_loading'] || props.formData?.[chartUniqueId + '_Obligations_Next_Respondent_loading'] || props.formData?.[chartUniqueId + '_Current_Steps_Members_loading'] ? props.loader : (
                                <React.Fragment>
                                    <DialogTitle id='customized-dialog-title' style={{ padding: '10px' }}>
                                        <Typography style={{ fontWeight: '400', fontSize: '14px', color: 'rgba(33, 33, 33, 1)', fontStyle: 'normal', lineHeight: '21px' }}>
                                            Assign to
                                        </Typography>
                                    </DialogTitle>
                                    <DialogContent dividers className={classes.dialogContentRoot}>
                                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '16px', gap: '16px', boxSizing: 'border-box' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                                <Typography style={{ fontWeight: '400', fontSize: '12px', color: 'rgba(120, 121, 142, 1)', fontStyle: 'normal', lineHeight: '17px' }}>
                                                    Search
                                                </Typography>
                                                <OutlinedInput
                                                    variant="outlined"
                                                    type={'string'}
                                                    classes={{ root: classes.inputRoot1 }}
                                                    inputProps={{ className: classes.inputText }}
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                    placeholder={"Search Here..."}
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <img
                                                                src="/media/svg/searchIcon.svg"
                                                                alt="Search"
                                                                style={{
                                                                    width: '18px',
                                                                    height: '18px',
                                                                    cursor: 'pointer',
                                                                    color: 'rgba(120, 121, 142, 1)'
                                                                }}
                                                            />
                                                        </InputAdornment>
                                                    }
                                                />
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', overflowY: 'auto', maxHeight: '300px' }} className='myScrollContainer'>
                                                {
                                                    filteredUsers.length > 0 ? (
                                                        filteredUsers.map((data, index) => {
                                                            return (
                                                                <div key={data.value || index} className={classes.rowStartCenter} style={{ gap: 8 }}>
                                                                    <Checkbox
                                                                        color="primary"
                                                                        inputProps={{ 'aria-label': `checkbox-${data.value}` }}
                                                                        checked={selectedAssigneeId?.value === data.value}
                                                                        onChange={() => setSelectedAssigneeId(data)}
                                                                    />
                                                                    <div className={classes.rowStartCenter} style={{ gap: 8 }}>
                                                                        <Avatar className={classes.purple} style={{
                                                                            height: 24,
                                                                            width: 24,
                                                                            fontSize: '11px',
                                                                            fontStyle: 'normal',
                                                                            fontWeight: 500,
                                                                            lineHeight: 'normal'
                                                                        }}>
                                                                            {getInitials(data.name || data.label)}
                                                                        </Avatar>
                                                                        <Typography component="span" className={classes.infoText}>
                                                                            {data.label}
                                                                        </Typography>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    ) : (
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            padding: '20px',
                                                            color: 'rgba(120, 121, 142, 1)',
                                                            fontSize: '14px'
                                                        }}>
                                                            {searchTerm ? 'No users found matching your search' : 'No users available'}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div >
                                    </DialogContent >
                                    <DialogActions style={{ height: '50px', padding: '10px', display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '10px', boxSizing: 'border-box' }}>
                                        <Button color="inherit" size="small" style={{ border: '1px solid #3F51B5', width: '80px', height: '100%', boxSizing: 'border-box', padding: '12px 16px', borderRadius: '4px', color: 'rgba(63, 81, 181, 1)', fontSize: '14px', fontWeight: '400', fontStyle: 'normal', lineHeight: '21px' }} onClick={() => onCloseModel()}>
                                            Close
                                        </Button>
                                        <Button

                                            size="small"
                                            style={{ border: '1px solid #3F51B5', width: '80px', height: '100%', boxSizing: 'border-box', padding: '12px 16px', borderRadius: '4px', color: 'rgba(255, 255, 255, 1)', fontSize: '14px', fontWeight: '400', fontStyle: 'normal', lineHeight: '21px', backgroundColor: 'rgba(63, 81, 181, 1)' }}
                                            onClick={() => {
                                                if (selectedAssigneeId && modalInfo.parent) {
                                                    onAssignToParent(selectedAssigneeId);
                                                }
                                                else if (selectedAssigneeId && modalInfo.nextRespondent) {
                                                    onAssignTo(selectedAssigneeId);
                                                }
                                                else if (selectedAssigneeId && !modalInfo.parent) {
                                                    onSaveMembersToFirstStep(selectedAssigneeId, modalInfo.data);
                                                }

                                            }}

                                        >
                                            Assign
                                        </Button>
                                    </DialogActions>
                                </React.Fragment>
                            )
                        }

                    </div >
                )
            }

        </Dialog >
    );
};

export default WorkFlowModelViewer
